/* Descripció completa a l'HTML; només es plega amb CSS i un control accessible a mòbil. */
(() => {
  const mobile = window.matchMedia("(max-width: 699px)");
  const initialized = new WeakSet();
  const init = (root = document) => {
    root.querySelectorAll("[data-mp-collection-description]").forEach((wrapper) => {
      if (initialized.has(wrapper)) return;
      const content = wrapper.querySelector(".collection-description__full") || wrapper;
      const button = wrapper.nextElementSibling;
      if (!button?.matches("[data-mp-description-toggle]")) return;
      initialized.add(wrapper);
      const update = () => {
        wrapper.toggleAttribute("data-mp-mobile-ready", mobile.matches);
        button.hidden = !mobile.matches || (wrapper.dataset.mpExpanded !== "true" && content.scrollHeight <= content.clientHeight + 1);
        // El contingut importat pot incloure enllaços: no poden rebre focus si estan retallats.
        content.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((element) => {
          const clipped = mobile.matches && !button.hidden && wrapper.dataset.mpExpanded !== "true";
          if (clipped && !element.hasAttribute("data-mp-original-tabindex")) {
            element.dataset.mpOriginalTabindex = element.getAttribute("tabindex") ?? "";
            element.setAttribute("tabindex", "-1");
          } else if (!clipped && element.hasAttribute("data-mp-original-tabindex")) {
            const original = element.dataset.mpOriginalTabindex;
            if (original === "") element.removeAttribute("tabindex");
            else element.setAttribute("tabindex", original);
            delete element.dataset.mpOriginalTabindex;
          }
        });
      };
      button.addEventListener("click", () => {
        if (!mobile.matches) return;
        const expanded = wrapper.dataset.mpExpanded !== "true";
        wrapper.dataset.mpExpanded = String(expanded);
        button.setAttribute("aria-expanded", String(expanded));
        button.textContent = expanded ? button.dataset.readLess : button.dataset.readMore;
        update();
      });
      mobile.addEventListener("change", update);
      new ResizeObserver(update).observe(content);
      update();
    });
  };
  init();
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();

/* Mostra la capçalera en pujar; no modifica hide_on_scroll ni els estats de Prestige. */
(() => {
  const mobile = window.matchMedia("(max-width: 999px)");
  const html = document.documentElement;
  let cleanup = () => {};

  const init = () => {
    cleanup();
    cleanup = () => {};
    if (!mobile.matches) return;
    const section = document.querySelector(".shopify-section--header");
    const header = section?.querySelector("x-header");
    if (!header) return;

    // Aquest marcador no té alçada i segueix el punt original quan el header és sticky.
    const marker = document.createElement("div");
    marker.setAttribute("aria-hidden", "true");
    section.before(marker);
    const controller = new AbortController();
    const options = { signal: controller.signal };
    let lastY = Math.max(0, window.scrollY);
    let distance = 0;
    let frame = 0;
    html.setAttribute("data-mp-mobile-header", "");

    const show = () => html.removeAttribute("data-mp-mobile-header-hidden");
    const isInteracting = () =>
      section.contains(document.activeElement) ||
      section.querySelector("[open]") ||
      document.documentElement.classList.contains("lock");

    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const delta = y - lastY;
      lastY = y;
      const markerTop = marker.getBoundingClientRect().top;
      html.toggleAttribute("data-mp-mobile-header-pinned", markerTop < 0);
      if (markerTop >= -header.offsetHeight || isInteracting()) {
        distance = 0;
        show();
        return;
      }
      // Llindars per evitar pampallugues amb petits moviments i el rebot d'iOS.
      if (delta !== 0) distance = Math.sign(delta) === Math.sign(distance) ? distance + delta : delta;
      if (distance >= 24) html.setAttribute("data-mp-mobile-header-hidden", "");
      else if (distance <= -8) show();
    };
    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };
    window.addEventListener("scroll", schedule, { ...options, passive: true });
    window.addEventListener("resize", schedule, options);
    section.addEventListener("focusin", show, options);
    document.addEventListener("dialog:before-show", show, options);
    update();

    cleanup = () => {
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
      marker.remove();
      html.removeAttribute("data-mp-mobile-header");
      html.removeAttribute("data-mp-mobile-header-hidden");
      html.removeAttribute("data-mp-mobile-header-pinned");
    };
  };

  mobile.addEventListener("change", init);
  document.addEventListener("shopify:section:load", init);
  init();
})();
